module.exports = __webpack_public_path__ + "static/media/truck.977e21e4.svg";